import isSmartReplyWithTextAtThirdPositionEnabled from './isSmartReplyWithTextAtThirdPositionEnabled';
import { FeatureNames, SmartPillsFeatureArrangement } from './constants';

/**
 * Retrieves smart pill features and the number of pill(s) for each feature types.
 * The return result may differ based on if the experiment feature flag is enabled.
 * @param smartPillReplyWithTextAtThirdPositionEnabled: Flag value is passed
 */
export default function getSmartPillsFeatureArrangements(): SmartPillsFeatureArrangement[] {
    /**
     * Feature flag to control if Smart Reply With Text pill should appear in the 3rd position in the Pill Framework.
     * selectArrangement() will traverse this structure until it finds an aggregation that can be fulfilled with existing smart pills
     * it's a first-served logic so it means that selectArrangement() will return the first that can be fulfilled
     * arrangement is the position that features will be finally rendered
     */
    const smartReplyWithTextAtThirdPositionEnabled: boolean = isSmartReplyWithTextAtThirdPositionEnabled();

    return [
        {
            aggregation: { SmartReply: 2, SmartTime: 1 },
            arrangement: smartReplyWithTextAtThirdPositionEnabled
                ? [FeatureNames.SmartTime, FeatureNames.SmartReply]
                : [FeatureNames.SmartReply, FeatureNames.SmartTime],
        },
        {
            aggregation: { SmartTime: 1 },
            arrangement: [FeatureNames.SmartTime],
        },
        {
            aggregation: { SmartReply: 2, SmartDoc: 1 },
            arrangement: smartReplyWithTextAtThirdPositionEnabled
                ? [FeatureNames.SmartDoc, FeatureNames.SmartReply]
                : [FeatureNames.SmartReply, FeatureNames.SmartDoc],
        },
        {
            aggregation: { SmartDoc: 1 },
            arrangement: [FeatureNames.SmartDoc],
        },
        {
            aggregation: { SmartReply: 2, SmartTodo: 1 },
            arrangement: smartReplyWithTextAtThirdPositionEnabled
                ? [FeatureNames.SmartTodo, FeatureNames.SmartReply]
                : [FeatureNames.SmartReply, FeatureNames.SmartTodo],
        },
        {
            aggregation: { SmartTodo: 1 },
            arrangement: [FeatureNames.SmartTodo],
        },
        {
            aggregation: { SmartReply: 1, SmartTodo: 1, SmartReminder: 1 },
            arrangement: smartReplyWithTextAtThirdPositionEnabled
                ? [FeatureNames.SmartTodo, FeatureNames.SmartReminder, FeatureNames.SmartReply]
                : [FeatureNames.SmartReply, FeatureNames.SmartTodo, FeatureNames.SmartReminder],
        },
        {
            aggregation: { SmartTodo: 1, SmartReminder: 1 },
            arrangement: [FeatureNames.SmartTodo, FeatureNames.SmartReminder],
        },
        {
            aggregation: { SmartReply: 3 },
            arrangement: [FeatureNames.SmartReply],
        },
    ];
}
